"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.invoiceOrderExcelApi = invoiceOrderExcelApi;
exports.invoiceOrderListApi = invoiceOrderListApi;
exports.invoiceSendStoreOrderApi = invoiceSendStoreOrderApi;
exports.invoiceSummaryOrderApi = invoiceSummaryOrderApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * @description  发货订单统计 列表
 */
function invoiceSummaryOrderApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/invoice/summary/order/list',
    method: 'get',
    params: params
  });
}

/**
 * @description  发货订单详细 列表
 */
function invoiceOrderListApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/invoice/order/list',
    method: 'get',
    params: params
  });
}

/**
 * @description
 */
function invoiceSendStoreOrderApi(data) {
  return (0, _request.default)({
    url: '/admin/merchant/invoice/store/send',
    method: 'post',
    data: data
  });
}

/**
 * @description
 */
/**
 * 订单导出API
 * @param params 对象
 */
function invoiceOrderExcelApi(params) {
  return (0, _request.default)({
    url: "/admin/merchant/export/invoice/order/excel",
    method: 'get',
    params: params
  });
}